import React, { useEffect } from "react";
import Filter from "../../components/filter/filter";
import OrganisationList from "../organisation/organisationList";
import HeroContent from "../hero/hero";
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import PropTypes from "prop-types";
import { RowFlexBox, ColumnFlexBox } from "../common/FlexBoxes";
import { fetchWelcomeContent } from "../../features/welcomeContent/welcomeContentActions";
import { ApplicationState } from "../../redux/initialState";
import { WelcomeContent } from "../../features/welcomeContent/welcomeContentTypes";
import { useBreakpoint, Heading2, Paragraph, Button, Icon, Link, Heading5, Modal } from "@tal-gel/components-v2";
import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";

interface PropsFromState {
  loading: boolean;
  data: WelcomeContent;
  errors?: string;
}

interface propsFromDispatch {
  fetchWelcomeContent: () => any;
}

type AllProps = PropsFromState & propsFromDispatch;

function isEmptyObject(obj: any) {
  return Object.keys(obj).length === 0;
}

const CenteredDiv = styled.div`
  display: flex;
  justify-content: center;
`;

const StyledColumnFlexBox = styled(ColumnFlexBox)`
  justify-content: center;
`;

const StyledRowFlexBox = styled(RowFlexBox)`
  padding-top: 52px;
  padding-bottom: 30px;
  border-bottom: 1px solid #e1e1e1;
  width: 100vw;
  justify-content: center;
`;

const InnerColumnFlexBox = styled(ColumnFlexBox)`
  max-width: 1080px;
  gap: 36px;
  padding-left: 32px;
  padding-right: 32px;
`;

const StyledButton = styled(Button)`
  margin-bottom: 22px;
`;

const ModalFilterRowFlexBox = styled(RowFlexBox)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalInnerRowFlexBox = styled(RowFlexBox)`
  max-width: 1080px;
  padding: 44px 0;
`;

const OrganisationListColumnFlexBox = styled(ColumnFlexBox)<{ bgColor: string }>`
  background-color: ${({ bgColor }) => bgColor};
  border-top: 1px solid #e1e1e1;
  padding: 32px;
  max-width: 1080px;
  margin: 0 auto;
`;

const Search: React.FC<AllProps> = ({ data, fetchWelcomeContent }) => {
  useEffect(() => {
    if (isEmptyObject(data)) {
      fetchWelcomeContent();
    }
  }, [data, fetchWelcomeContent]);

  const filter = React.createRef<HTMLDivElement>();
  const [modalVisible, setModalVisible] = React.useState(false);
  const isLargerThanSmScreen = useBreakpoint("sm");
  const isMediumOrLarger = useBreakpoint("md");
  const isLargeOrLarger = useBreakpoint("lg");
  const theme = useTheme();

  return (
    <>
      <CenteredDiv>{isLargerThanSmScreen && <HeroContent />}</CenteredDiv>
      <StyledColumnFlexBox>
        <StyledRowFlexBox>
          <InnerColumnFlexBox>
            {isMediumOrLarger ? (
              <Heading2 style={{ margin: "0" }}>{data.welcomeTitle}</Heading2>
            ) : (
              <Heading5 style={{ margin: "0" }}>{data.welcomeTitle}</Heading5>
            )}
            <Paragraph>{data.welcomeDescription}</Paragraph>
            <Paragraph>{data.welcomeDescription2}</Paragraph>
            <div>
              {isLargeOrLarger ? (
                <StyledButton
                  variant="primary"
                  iconRight={<Icon name="ArrowDown" />}
                  size="large"
                  onClick={() => {
                    if (filter && filter.current) {
                      filter.current.scrollIntoView();
                    }
                  }}
                >
                  Get Started
                </StyledButton>
              ) : (
                <ColumnFlexBox>
                  <Button
                    style={{ width: "200px" }}
                    iconRight={<Icon name="ArrowDown" />}
                    variant="primary"
                    size="large"
                    onClick={() => setModalVisible(true)}
                  >
                    Get Started
                  </Button>
                  <br />
                  {!isMediumOrLarger && <Link onClick={() => setModalVisible(true)}>Search filters</Link>}
                </ColumnFlexBox>
              )}
            </div>
          </InnerColumnFlexBox>
        </StyledRowFlexBox>
        {!isLargeOrLarger && (
          <Modal
            isOpen={modalVisible}
            onOpenChange={isOpen => setModalVisible(isOpen)}
            title={<Heading5>Filter</Heading5>}
            size="small"
            fullscreen="never"
            closeButton="show"
            zIndex={1000}
            action={
              <Button variant="primary" size="large" onClick={() => setModalVisible(false)}>
                Filter
              </Button>
            }
          >
            <Filter />
            <br />
          </Modal>
        )}
        {isMediumOrLarger && (
          <ModalFilterRowFlexBox ref={filter} id="filter">
            <ModalInnerRowFlexBox>
              <Filter key={"desktop"} />
            </ModalInnerRowFlexBox>
          </ModalFilterRowFlexBox>
        )}
        <OrganisationListColumnFlexBox bgColor={theme.tokens.global.themeColorBackgroundLight}>
          <OrganisationList />
        </OrganisationListColumnFlexBox>
      </StyledColumnFlexBox>
    </>
  );
};

const mapStateToProps = ({ welcomeContent }: ApplicationState) => ({
  loading: welcomeContent.loading,
  errors: welcomeContent.errors,
  data: welcomeContent.data,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    fetchWelcomeContent: () => {
      dispatch(fetchWelcomeContent());
    },
  };
};

Search.propTypes = {
  loading: PropTypes.any,
  errors: PropTypes.string,
  data: PropTypes.any.isRequired,
  fetchWelcomeContent: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Search);
